import { buttonReset } from '../Button'
import { StyleFn } from '..'

export const Card: StyleFn = (theme) => {
  const {
    color,
    elevation,
    font,
    size: { spacing },
  } = theme

  const transitionDuration = '250ms'
  const transitionFunction = 'cubic-bezier(.4,.8,0,.99)'

  const applyBoxShadow = (boxShadow: string, opacity: number) => {
    return {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 3,
      boxShadow,
      transition: `opacity ${transitionDuration} ${transitionFunction}`,
      opacity,
      pointerEvents: 'none',
    }
  }
  return {
    root: {
      position: 'relative',
      boxSizing: 'border-box',
      display: 'block',
      minWidth: spacing[16],
      minHeight: spacing[16],
      maxWidth: '19.5rem',
      borderRadius: 3,
      color: color.getModalValues(color.text.primary),
      backgroundColor: color.getModalValues(color.background.primary),
      textAlign: 'left',
      // pseudo selectors with an opacity transition
      // more performant than using a transition on box-shadow
      '&:before': applyBoxShadow(elevation.level2, 1),
      '&:after': applyBoxShadow(elevation.level4, 0),
    },
    _actionable: {
      // FIXME actionable cards should be tabbable
      // with <div class="ds-card-action-area" tabIndex="0" role="button">
      // and a focus-within style maybe
      // "&:focus-within": {
      //   outline: `1px solid ${color.getModalValues(color.border.focus)}`,
      // },
      '&:hover:before, &:active:before': { opacity: 0 },
      '&:hover:after, &:active:after': { opacity: 1 },
      '&:not(:has($actions)) $actionArea': {
        height: '100%',
      },
    },
    _selected: {
      outline: `2px solid ${color.getModalValues(color.border.focus)}`,
    },
    translate: {
      position: 'relative',
      '& $_actionable': {
        transition: `transform ${transitionDuration} ${transitionFunction}`,
      },
      '&:hover': {
        // prevent transition flickering when
        // by adding a 8px element at the bottom
        '&:after': {
          content: '""',
          position: 'absolute',
          height: spacing[4],
          bottom: '-' + spacing[4],
          right: 0,
          left: 0,
        },
        '& $_actionable': {
          transform: `translateY(-${spacing[4]})`,
        },
      },
    },
    media: {
      display: 'block',
      minHeight: spacing[112],
      width: '100%',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderRadius: '3px 3px 0 0',
      // used when card-media is applied to an img
      // not IE11 compatible
      objectFit: 'cover',
    },
    content: {
      fontSize: font.size.small,
      lineHeight: font.lineheight.small,
      padding: spacing[24],
      '& p': {
        margin: 0,
      },
    },
    title: {
      fontSize: font.size['heading-6'],
      lineHeight: font.lineheight['heading-6'],
      marginBottom: spacing[8],
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      padding: spacing[24],
      paddingBottom: 0,
      marginBottom: spacing[8],
      '& + $content': {
        paddingTop: 0,
      },
    },
    headerTitle: {
      fontSize: font.size['heading-6'],
      lineHeight: font.lineheight['heading-6'],
      marginBottom: 0,
    },
    headerIcon: {
      marginRight: spacing[16],
      fontSize: spacing[24],
      height: spacing[24],
    },
    headerAction: {
      marginLeft: 'auto',
      marginRight: `-${spacing[8]}`,
    },
    actionArea: {
      ...buttonReset,
      width: '100%',
      display: 'block',
      textAlign: 'inherit',
      whiteSpace: 'normal',
      cursor: 'pointer',
      '&:focus': {
        outline: 0,
      },
      '&:active': {
        backgroundColor: color.getModalValues(color.neutral.lighter),
      },
      '& $content': {
        paddingBottom: spacing[16],
      },
    },
    actions: {
      display: 'flex',
      alignItems: 'center',
      padding: spacing[24],
      paddingTop: spacing[8],
      justifyContent: 'flex-end',
      '& > :not(:first-child)': {
        marginLeft: spacing[8],
      },
    },
  }
}
